import { RecurrenceTypeEnum } from 'graphql/types';

export { RecurrenceTypeEnum };

/** Legacy repeatInterval values before recurrenceType was introduced. */
const LEGACY_WEEKDAYS_INTERVAL = 100;
const LEGACY_WEEKENDS_INTERVAL = 101;

export const recurringPatternOptions = [
  { label: 'All days', value: RecurrenceTypeEnum.RepeatDays },
  { label: 'Weekdays', value: RecurrenceTypeEnum.Weekdays },
  { label: 'Weekends', value: RecurrenceTypeEnum.Weekends },
];

export const defaultRecurringPattern = RecurrenceTypeEnum.RepeatDays;

export function resolveRecurrenceForApi(
  repeatDayInterval?: number | null,
  recurringPattern?: RecurrenceTypeEnum | null,
): { recurrenceType: RecurrenceTypeEnum; repeatInterval: number } {
  if (recurringPattern === RecurrenceTypeEnum.Weekdays) {
    return { recurrenceType: RecurrenceTypeEnum.Weekdays, repeatInterval: 0 };
  }

  if (recurringPattern === RecurrenceTypeEnum.Weekends) {
    return { recurrenceType: RecurrenceTypeEnum.Weekends, repeatInterval: 0 };
  }

  if (!repeatDayInterval) {
    return { recurrenceType: RecurrenceTypeEnum.None, repeatInterval: 0 };
  }

  return {
    recurrenceType: RecurrenceTypeEnum.RepeatDays,
    repeatInterval: repeatDayInterval,
  };
}

export function splitRecurringFormValues(
  recurrenceType?: RecurrenceTypeEnum | null,
  repeatInterval?: number | null,
): {
  repeatDayInterval: number;
  recurringPattern: RecurrenceTypeEnum;
} {
  if (recurrenceType === RecurrenceTypeEnum.Weekdays) {
    return { repeatDayInterval: 1, recurringPattern: RecurrenceTypeEnum.Weekdays };
  }

  if (recurrenceType === RecurrenceTypeEnum.Weekends) {
    return { repeatDayInterval: 1, recurringPattern: RecurrenceTypeEnum.Weekends };
  }

  if (recurrenceType === RecurrenceTypeEnum.RepeatDays) {
    return {
      repeatDayInterval: Number(repeatInterval) || 1,
      recurringPattern: RecurrenceTypeEnum.RepeatDays,
    };
  }

  const interval = Number(repeatInterval) || 0;

  if (!interval) {
    return { repeatDayInterval: 0, recurringPattern: defaultRecurringPattern };
  }

  if (interval === LEGACY_WEEKDAYS_INTERVAL) {
    return { repeatDayInterval: 1, recurringPattern: RecurrenceTypeEnum.Weekdays };
  }

  if (interval === LEGACY_WEEKENDS_INTERVAL) {
    return { repeatDayInterval: 1, recurringPattern: RecurrenceTypeEnum.Weekends };
  }

  return { repeatDayInterval: interval, recurringPattern: RecurrenceTypeEnum.RepeatDays };
}
